import { UserAttrSkillWrapper } from '../skills/userattrskillwrapper';
import { Location } from './Location';
import _ from 'lodash';

export class UserPersonalInformation {
  public firstName: string = '';
  public lastName: string = '';p
  public middleName: string = '';
  public preferredName: string = '';
  public email: string = '';
  public phoneNumber: string = '';
  public address1: string = '';
  public address2: string = '';
  public city: string = '';
  public state: string = '';
  public zip: number | string = 0;
  public timezone: string = '';
  public country: string = '';
  public profilePicGUID: string = '';
  public userProfileBasePath: string = '';
  public profilePicExtType: string = '';
  
  public userAttributeSkills: UserAttrSkillWrapper[] = [];
  public newPassword: string = '';
  public oldPassword: string = '';
  public currentPassword: string = '';
  
  public desiredLocations: Location[] = [];
  public jobAvailability: string = '';

  public remoteWork: boolean = false;
  public periodForSalary: string = '';

  public currency: string = '';
  public desiredLocationString: string = '';
  public sourceType: string = '';


  public totalFlightHours: string = '';

  public role: string = '';

  public getFullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  public getFullAddress() {
    let UserAddress =
      this.address1 +
      (!this.address1 ? '' : ', ') +
      (this.address2 === undefined ? '' : this.address2) +
      (!this.address2 ? '' : ', ') +
      this.city +
      (!this.city ? '' : ', ') +
      this.state +
      (!this.state ? '' : ', ') +
      this.zip +
      (!this.country ? '' : ', ') +
      _.capitalize(this.country);
    UserAddress = UserAddress.replace(/null,/g, '').replace(/null/g, '');
    if (typeof UserAddress !== 'undefined') {
      return UserAddress;
    }
    return '';
  }
}
